/* import __COLOCATED_TEMPLATE__ from './settings-divider.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Signature {
  Args: {
    icon: InterfaceIconName;
    dividerText: string;
  };
}

const SettingsDivider = templateOnlyComponent<Signature>();
export default SettingsDivider;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::NumberConfiguration::SettingsDivider': typeof SettingsDivider;
    'operator/fin/setup/sections/number-configuration/settings-divider': typeof SettingsDivider;
  }
}
